<template>
  <div class="integration">
    <SidebarLayout2 :breadcrumb="breadcrumb" :pageTitle="pageTitle">
      <!-- BARRA LATERAL -->
      <template #sidebar>
        <!-- AÇÕES DA PÁGINA -->
        <SidebarBlock> </SidebarBlock>
      </template>

      <!-- CONTEÚDO -->
      <template #content>
        <div class="filters">
          <SearchInput
            v-model="searchTerm"
            class="filters--search_width"
            @keypress.enter="searchTermSelected = $event.target.value"
            @selectItem="searchSelectedItemHandler"
          />
        </div>

        <!-- TABELA -->
        <Datatable
          :cols="gridColumns"
          :rows="gridData"
          :filterKey="filterKey"
          :colsMinWidths="colsWidths"
          :noFrames="true"
          :sortable="true"
          :searchableColumns="['nomeHotel']"
          :isLoading="isLoadingTableContent"
          class="datatable"
          ref="datatable"
          notFoundMessage="Não há hoteis correspondentes com a busca."
        >
          <template v-slot:acoes="slotProps">
            <router-link
              :to="
                `/configuracoes/configuracao-integracoes/editar/${slotProps.rowDataObj.codigoHotel}`
              "
              class="datatable-actions--edit"
              >Editar</router-link
            >
          </template>
        </Datatable>
      </template>
    </SidebarLayout2>
  </div>
</template>

<script>
import debounce from 'lodash.debounce'
import SidebarLayout2 from '@/layouts/SidebarLayout2'
import SearchInput from '@/components/_base/elements/SearchInput'
import Datatable from '@/components/_base/patterns/DataTable'
import SidebarBlock from '@/components/_base/patterns/SidebarBlock'

export default {
  name: 'integration',
  components: {
    SidebarLayout2,
    SearchInput,
    Datatable,
    SidebarBlock
  },
  data() {
    return {
      isLoadingTableContent: true,
      breadcrumb: [
        {
          label: 'Configurações'
        },
        {
          label: 'Integrações',
          url: '/configuracoes/configuracao-integracoes',
          isSpa: true /** se deve ser um link para o site novo ou antigo */
        }
      ],
      pageTitle: 'Integrações',
      searchTerm: '',
      searchTermSelected: '',
      gridData: [],
      colsWidths: {
        hotel: '50%'
      } /** objeto com os tamanhos mínimos de cada coluna */,
      gridColumns: [
        /** colunas do grid */
        { name: 'codigoHotel', alias: 'Código Hotel' },
        { name: 'nomeHotel', alias: 'Hotel' },
        { name: 'nomeServico', alias: 'Serviço' },
        { name: 'acoes', alias: '' }
      ]
    }
  },
  computed: {
    filterKey() {
      if (this.searchTerm.trim() !== '') return this.searchTermSelected

      return ''
    },
    filterValues() {
      return {}
    }
  },
  watch: {
    searchTerm(newValue) {
      if (newValue === '') this.searchTermSelected = newValue
    },
    filterValues: {
      handler: debounce(function(newVal, oldVal) {
        if (newVal.status !== oldVal.status || newVal.rates !== oldVal.rates) {
          this.filterHotels()
        }
      }, 1000)
    }
  },
  created() {
    this.filterHotels()
  },
  mounted() {
    /** Cria um atributo não reativo */
    this.datatableHead = this.$refs['datatable'].$el.querySelector('.thead')
    /** Adiciona a escuta do evento de scroll */
    document.addEventListener('scroll', this.scrollHandler)
  },
  beforeDestroy() {
    document.removeEventListener('scroll', this.scrollHandler)
  },
  methods: {
    searchSelectedItemHandler(value) {
      this.$router.push({
        path: value.item.link
      })
    },
    filterHotels() {
      this.isLoadingTableContent = true

      this.$integrations
        .getConfigs()
        .then((response) => {
          const hotellList = response.data

          this.gridData = this.gridData = this.standardizeHotelData(hotellList)
          this.isLoadingTableContent = false
        })
        .catch((error) => {
          this.$bus.$emit('show-alert-chip', {
            message: error
          })
        })
    },
    standardizeHotelData(response) {
      return response.map((item) => {
        const obj = {
          data: item
        }

        return obj
      })
    },
    /** gerencia o scroll na página */
    scrollHandler() {
      /** Adiciona a classe de estilo no header da tabela quando fixa no topo */
      if (this.datatableHead.getBoundingClientRect().y === 50) {
        if (!this.datatableHead.classList.contains('scrolled')) {
          this.datatableHead.classList.add('scrolled')
        }
      } else {
        if (this.datatableHead.classList.contains('scrolled')) {
          this.datatableHead.classList.remove('scrolled')
        }
      }
    }
  }
}
</script>

<style lang="scss" scoped>
::v-deep .lb-breadcrumb--link:nth-child(2) {
  cursor: default;
}
.icon-color {
  color: #c2c2c2;
}

/**
* Espacamento padrao
* Ref: https://www.figma.com/file/9AFe6i7bVhMup1bYeppCU7/Tarifas?node-id=0%3A1
*/
.filters {
  padding: {
    bottom: 30px;
  }

  &--search_width {
    width: 214px;
  }
}
/**
* Espacamento padrao
* Ref: https://www.figma.com/file/9AFe6i7bVhMup1bYeppCU7/Tarifas?node-id=0%3A1
*/
.datatable {
  max-height: initial;
  overflow: initial;
  ::v-deep {
    .thead {
      top: 50px;

      &:before,
      &:after {
        content: '';
        width: 50px;
        height: 100%;
        position: absolute;
        top: 0;
        background-color: $white;
        right: 100%;
      }

      &::after {
        right: initial;
        left: 100%;
      }
    }
  }

  &-actions {
    &--edit {
      color: $primary;

      &:hover,
      &:focus,
      &:active {
        background: none;
        text-decoration: underline;
      }
    }
  }
}
</style>
